"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageSearchInput = void 0;
var react_1 = __importStar(require("react"));
var react_select_1 = __importDefault(require("react-select"));
var throttle_debounce_1 = require("throttle-debounce");
require("./PackageSearchInput.scss");
var ReactSelect_1 = require("@app/components/controls/ReactSelect");
var constants_1 = require("@app/shared/constants");
var initialState = {
    inputValue: ''
};
var PackageSearchInput = /** @class */ (function (_super) {
    __extends(PackageSearchInput, _super);
    function PackageSearchInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - End */
        /* Component Methods - Begin */
        _this.callOnChange = function () {
            _this.props.onChange(_this.state.inputValue);
        };
        _this.handleSearchClear = function (value, action) {
            if (action.action === 'clear') {
                _this.setState({ inputValue: '' }, function () {
                    _this.debouncedOnChange();
                });
            }
        };
        _this.handleSearchKey = function (e) {
            if (e.charCode === constants_1.KEY_ENTER || e.key === constants_1.KEY_ENTER_VALUE) {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        _this.handleSearchLookup = function (value, action) {
            if (action.action === 'input-change') {
                _this.setState({ inputValue: value }, function () {
                    _this.debouncedOnChange();
                });
            }
        };
        _this.debouncedOnChange = throttle_debounce_1.debounce(500, _this.callOnChange);
        _this.state = {
            inputValue: props.value ? props.value : ''
        };
        return _this;
    }
    /* Component Lifecycle Methods - Begin */
    PackageSearchInput.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ inputValue: this.props.value ? this.props.value : '' });
        }
    };
    /* Component Methods - End */
    PackageSearchInput.prototype.render = function () {
        var selectedValue = (this.state.inputValue === '') ?
            null : { label: this.state.inputValue, value: this.state.inputValue };
        return (react_1.default.createElement(react_select_1.default, { backspaceRemovesValue: false, className: "package-search-input", classNamePrefix: "package-search-input", controlShouldRenderValue: false, components: {
                DropdownIndicator: ReactSelect_1.SearchDropdownIndicator,
                IndicatorSeparator: ReactSelect_1.IndicatorSeparator,
                Menu: ReactSelect_1.Menu
            }, defaultInputValue: this.state.inputValue, inputValue: this.state.inputValue, isClearable: true, isSearchable: true, name: 'package-search-term', onChange: this.handleSearchClear.bind(this), onInputChange: this.handleSearchLookup.bind(this), onKeyDown: this.handleSearchKey.bind(this), options: [], placeholder: this.props.placeholder ? this.props.placeholder : 'Search...', value: selectedValue }));
    };
    return PackageSearchInput;
}(react_1.Component));
exports.PackageSearchInput = PackageSearchInput;
